import { ApolloError, useQuery } from '@apollo/client'
import { COMPANIES_OF_NETWORK_OR_COMPANY_MANAGER_OR_HRBP } from '../Queries'
import {
  FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQuery,
  FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQueryVariables,
} from '../../../types'

export const useCompaniesOfNetworkOrCompanyManagerOrHRBP = (): {
  data: FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<
    FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQuery,
    FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQueryVariables
  >(COMPANIES_OF_NETWORK_OR_COMPANY_MANAGER_OR_HRBP)

  return { data, error, loading }
}
